import { IrreversibleConfirmModal } from 'components/shared/Modals/IrreversibleConfirmModal';
import {
  connectDeleteFormConfirmationModal,
  DeleteFormConfirmationModalProps,
} from 'components/Workspaces/Batch/DeleteFormConfirmationModal/DeleteFormConfirmationModal.connect';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

export const DeleteFormConfirmationModal: FC<DeleteFormConfirmationModalProps> = ({
  onClose,
  onConfirm,
  isDeleteFormConfirmationModalOpen,
  nbOfFormsSelected,
}) => {
  return (
    <IrreversibleConfirmModal
      onClosed={onClose}
      onConfirm={onConfirm}
      isOpen={isDeleteFormConfirmationModalOpen}
      title={
        <FormattedMessage
          id={
            nbOfFormsSelected === 1
              ? 'batchPricer.modal.deleteForm.title.single'
              : 'batchPricer.modal.deleteForm.title.multiple'
          }
        />
      }
      description={
        <p>
          <FormattedMessage
            id={
              nbOfFormsSelected === 1
                ? 'batchPricer.modal.deleteForm.content.single'
                : 'batchPricer.modal.deleteForm.content.multiple'
            }
            values={{ nbForms: nbOfFormsSelected }}
          />
        </p>
      }
    />
  );
};

export const ConnectedDeleteFormConfirmationModal = connectDeleteFormConfirmationModal(DeleteFormConfirmationModal);
